import { EnumSchema } from '../metadata-schema';

export const Vaardigheid: EnumSchema = {
	"type": "string",
	"title": "Vaardigheid",
	"enum": [
		"Leesvaardigheid",
		"Taalverzorging",
		"Rekenen",
		"Woordenschat"
	]
};
